// usePresenceState.ts
// Manages player state and syncing from presence and DB
import { useState, useCallback } from 'react';

import { supabase } from '@lib/supabase';

import { mapDbPlayersToAppPlayers } from './presenceUtils'; // Assume mapping util exists

export function usePresenceState(roomId: string) {
  const [players, setPlayers] = useState<any[]>([]);
  const [isReady, setIsReady] = useState(false);

  // Sync players from DB
  const syncPlayersFromDb = useCallback(async () => {
    if (!roomId) return;
    const { data: dbPlayers, error } = await supabase
      .from('multiplayer_game_room_players')
      .select('*')
      .eq('room_id', roomId);
    if (!error && dbPlayers) {
      setPlayers(mapDbPlayersToAppPlayers(dbPlayers));
    }
  }, [roomId]);

  // Sync players from presence event (e.g., Supabase presence list)
  const syncPlayersFromPresence = useCallback((presenceList: any[]) => {
    // Assume presenceList is an array of presence objects with user_id, name, avatar, etc.
    setPlayers(presenceList.map((p: any) => ({
      user_id: p.user_id,
      name: p.name,
      avatar_url: p.avatar_url,
      is_ready: p.is_ready ?? false,
      score: p.score ?? 0,
    })));
  }, []);

  return { players, setPlayers, isReady, setIsReady, syncPlayersFromDb, syncPlayersFromPresence };
}

